import React from 'react'
import { Link } from 'react-router-dom'
import { array } from 'prop-types'
import styles from './Speak.styl'
import Popup from './Popup'

const titleData = 'SERVIÇOS COMPLEMENTARES'
const linkData = [
	'Nutrição',
	'Medicina Desportiva',
	'Avaliação de Rendimento',
	'Monitorização'
]

export default class Speak extends React.Component {
	static propTypes = {
		complementary: array
	}
	state = {
		service: null
	}

	links() {
		const { complementary } = this.props
		if (Array.isArray(complementary)) {
			return complementary.map((links, index) => (
				<div
					onClick={ () => { this.setState({ service: links }) } }
					key={ index }
					className={ styles.headerButton }
				>
					{ links.card.title }
				</div>
			)
			)
		}
		return null
	}

	render() {
		const { service } = this.state
		return (
			<section className={ styles.section }>
				{ service ?
					<Popup
						service={ service }
						close={ () => { this.setState({ service: false }) } }
					/> : null }
				<div className={ styles['content'] }>
					<h2>{ titleData }</h2>
					<div className={ styles.buttonCol }>
						{ this.links() }
					</div>
				</div>
			</section>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/website/pages/HomePage/components/Speak/Speak.js